<template>
    <section class="ifr__section ifr__section--stories">
        <div class="-ui-container">
            <header class="ifr__header">
                <h4>{{ $t('stories.header.h4') }}</h4>
                <h3 v-html="$t('stories.header.h3')"></h3>
                <div class="ifr__header-content" v-html="$t('stories.header.content')"></div>
            </header>
        </div>
        <div class="-ui-container -ui-container-lg ifr__stories">
            <div class="-ui-grid">
                <div class="-ui-col-33 ifr__story" target="_blank">
                    <a href="" tatget="_blank">
                        <h3>{{ $t('stories.content.1.title') }}</h3>
                        <img src="../assets/img/IG_chile.jpg" :alt="$t('stories.content.1.title')">
                    </a>
                </div>
                <div class="-ui-col-33 ifr__story" target="_blank">
                    <a href="" tatget="_blank">
                        <h3>{{ $t('stories.content.2.title') }}</h3>
                        <img src="../assets/img/IG_ecuador.jpg" :alt="$t('stories.content.2.title')">
                    </a>
                </div>
                <div class="-ui-col-33 ifr__story" target="_blank">
                    <a href="" tatget="_blank">
                        <h3>{{ $t('stories.content.3.title') }}</h3>
                        <img src="../assets/img/IG_mexico.jpg" :alt="$t('stories.content.3.title')">
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'stories'
}
</script>

